export interface QuestionAnswerModel {
  answerText: string;
  answerValue: number;
}
